<app-navbar></app-navbar>

@let smallScreenLandingPage = smallScreen$ | async;
@let mediumScreenLandingPage = mediumScreen$ | async;
@let largeScreenLandingPage = largeScreen$ | async;

<app-opening (arrowClick)="scrollToElement(demoStep)" (getStartedClick)="loginService.navToGoogleAuth()" />

<div id="lp-step-2" #demoStep [ngClass]="{smallScreenLandingPage, mediumScreenLandingPage, largeScreenLandingPage}">
    <h2>{{ 'landing_page.step_2.title' | translate}}</h2>
    <app-demo-player />
    <p>Grâce à SVET, parlez en Français, traduisez le en Anglais, et pourquoi pas en Allemand ? Accédez à plus de 15
        langues différentes en gardant le timbre de voix de l'interlocuteur principal.</p>
    <div class="gradient-top"></div>
</div>

<div id="lp-step-3" #featuresStep [ngClass]="{smallScreenLandingPage, mediumScreenLandingPage, largeScreenLandingPage}">
    <div class="gradient-linear-background"></div>
    <div id="features-conent">
        <div id="features-infos">
            <!-- <h3>{{ 'landing_page.step_3.title' | translate }}</h3> -->
            <h3>Enregistrez en <app-shuffle-languages [timer]="4000" [languageList]="languagesSet1" /> partagez en
                <app-shuffle-languages [timer]="4000" [delay]="500" [languageList]="languagesSet2" />
            </h3>

            <p>{{ 'landing_page.step_3.baseline' | translate }}</p>
            <app-button type="get-started" (onClick)="loginService.navToGoogleAuth()">{{ 'common.get_started' |
                translate }}</app-button>
        </div>
        <ul id="features-wrapper">
            @for (feature of features; track $index) {
            <li class="feature">
                <!-- <img class="illustration" [src]="feature.imgUrl"
                    [alt]="'svet feature ' + feature.name + ' illustration'"> -->
                <div class="name">{{ 'landing_page.step_3.features.' + feature.name | translate}}</div>
            </li>
            }
        </ul>
    </div>
</div>

<div id="lp-step-4" #pricingStep [ngClass]="{smallScreenLandingPage, mediumScreenLandingPage, largeScreenLandingPage}">
    <h2>Tarifs</h2>
    @defer (on viewport) {
    <app-pricing></app-pricing>
    } @placeholder {
    <div></div>
    }
    <div class="gradient-top"></div>
</div>

<app-footer></app-footer>